export const SELECT_ALL_ROWS_LIMIT = 1000;
export const SELECT_ALL_ROWS_LIMIT_REALTIME = 10000;

export const DepartmentKeys: any = {
  c_suite: 'C-Suite',
  master_operations: 'Operations',
  finance_executive: 'Finance Executive',
  master_finance: 'Finance',
  design: 'Design',
  master_sales: 'Sales',
  master_engineering_technical: 'Engineering & Technical',
  founder: 'Founder',
  education: 'Education',
  master_legal: 'Legal',
  master_human_resources: 'Human Resources',
  master_information_technology: 'Information Technology',
  medical_health: 'Medical & Health',
  human_resources_executive: 'Human Resources Executive',
  information_technology_executive: 'Information Technology Executive',
  legal_executive: 'Legal Executive',
  marketing_executive: 'Marketing Executive',
  medical_health_executive: 'Medical & Health Executive',
  operations_executive: 'Operations Executive',
  sales_executive: 'Sales Leader',
  product_development: 'Product development',
  product_management: 'Product management',
  artificial_intelligence_machine_learning: 'Artificial Intelligence / Machine Learning',
  bioengineering: 'Bioengineering',
  biometrics: 'Biometrics',
  business_intelligence: 'Business Intelligence',
  chemical_engineering: 'Chemical Engineering',
  cloud_mobility: 'Cloud / Mobility',
  data_science: 'Data Science',
  devops: 'DevOps',
  digital_transformation: 'Digital Transformation',
  emerging_technology_innovation: 'Emerging Technology / Innovation',
  engineering_technical: 'Engineering & Technical',
  industrial_engineering: 'Industrial Engineering',
  mechanic: 'Mechanic',
  mobile_development: 'Mobile Development',
  project_management: 'Project Management',
  research_development: 'Research & Development',
  scrum_master_agile_coach: 'Scrum Master / Agile Coach',
  software_development: 'Software Development',
  support_technical_services: 'Support / Technical Services',
  technician: 'Technician',
  technology_operations: 'Technology Operations',
  test_quality_assurance: 'Test / Quality Assurance',
  ui_ux: 'UI / UX',
  web_development: 'Web Development',
  all_design: 'All Design',
  product_ui_ux_design: 'Product or UI/UX Design',
  graphic_design: 'Graphic / Visual / Brand Design',
  teacher: 'Teacher',
  principal: 'Principal',
  superintendent: 'Superintendent',
  professor: 'Professor',
  accounting: 'Accounting',
  finance: 'Finance',
  financial_planning_analysis: 'Financial Planning & Analysis',
  financial_reporting: 'Financial Reporting',
  financial_strategy: 'Financial Strategy',
  financial_systems: 'Financial Systems',
  internal_audit_control: 'Internal Audit & Control',
  investor_relations: 'Investor Relations',
  mergers_acquisitions: 'Mergers & Acquisitions',
  real_estate_finance: 'Real Estate Finance',
  financial_risk: 'Financial Risk',
  shared_services: 'Shared Services',
  sourcing_procurement: 'Sourcing / Procurement',
  tax: 'Tax',
  treasury: 'Treasury',
  compensation_benefits: 'Compensation & Benefits',
  'Diversity & Inclusion': 'Culture',
  employee_labor_relations: 'Employee & Labor Relations',
  health_safety: 'Health & Safety',
  human_resource_information_system: 'Human Resource Information System',
  human_resources: 'Human Resources',
  hr_business_partner: 'HR Business Partner',
  learning_development: 'Learning & Development',
  organizational_development: 'Organizational Development',
  recruiting_talent_acquisition: 'Recruiting & Talent Acquisition',
  talent_management: 'Talent Management',
  workforce_mangement: 'Workforce Management',
  people_operations: 'People Operations',
  application_development: 'Application Development',
  business_service_management_itsm: 'Business Service Management / ITSM',
  collaboration_web_app: 'Collaboration & Web App',
  data_center: 'Data Center',
  data_warehouse: 'Data Warehouse',
  database_administration: 'Database Administration',
  ecommerce_development: 'eCommerce Development',
  enterprise_architecture: 'Enterprise Architecture',
  help_desk_desktop_services: 'Help Desk / Desktop Services',
  hr_financial_erp_systems: 'HR / Financial / ERP Systems',
  information_security: 'Information Security',
  information_technology: 'Information Technology',
  infrastructure: 'Infrastructure',
  it_asset_management: 'IT Asset Management',
  it_audit_it_compliance: 'IT Audit / IT Compliance',
  it_operations: 'IT Operations',
  it_procurement: 'IT Procurement',
  it_strategy: 'IT Strategy',
  it_training: 'IT Training',
  networking: 'Networking',
  project_program_management: 'Project & Program Management',
  quality_assurance: 'Quality Assurance',
  retail_store_systems: 'Retail / Store Systems',
  servers: 'Servers',
  storage_disaster_recovery: 'Storage & Disaster Recovery',
  telecommunications: 'Telecommunications',
  virtualization: 'Virtualization',
  acquisitions: 'Acquisitions',
  compliance: 'Compliance',
  contracts: 'Contracts',
  corporate_secretary: 'Corporate Secretary',
  ediscovery: 'eDiscovery',
  ethics: 'Ethics',
  governance: 'Governance',
  governmental_affairs_regulatory_law: 'Governmental Affairs & Regulatory Law',
  intellectual_property_patent: 'Intellectual Property & Patent',
  labor_employment: 'Labor & Employment',
  lawyer_attorney: 'Lawyer / Attorney',
  legal: 'Legal',
  legal_counsel: 'Legal Counsel',
  legal_operations: 'Legal Operations',
  litigation: 'Litigation',
  privacy: 'Privacy',
  advertising: 'Advertising',
  brand_management: 'Brand Management',
  content_marketing: 'Content Marketing',
  customer_experience: 'Customer Experience',
  customer_marketing: 'Customer Marketing',
  demand_generation: 'Demand Generation',
  digital_marketing: 'Digital Marketing',
  ecommerce_marketing: 'eCommerce Marketing',
  event_marketing: 'Event Marketing',
  field_marketing: 'Field Marketing',
  lead_generation: 'Lead Generation',
  master_marketing: 'Marketing',
  marketing_analytics_insights: 'Marketing Analytics / Insights',
  marketing_communications: 'Marketing Communications',
  marketing_operations: 'Marketing Operations',
  product_marketing: 'Product Marketing',
  public_relations: 'Public Relations',
  search_engine_optimization_pay_per_click: 'Search Engine Optimization / Pay Per Click',
  social_media_marketing: 'Social Media Marketing',
  strategic_communications: 'Strategic Communications',
  technical_marketing: 'Technical Marketing',
  anesthesiology: 'Anesthesiology',
  chiropractics: 'Chiropractics',
  clinical_systems: 'Clinical Systems',
  dentistry: 'Dentistry',
  dermatology: 'Dermatology',
  doctors_physicians: 'Doctors / Physicians',
  epidemiology: 'Epidemiology',
  first_responder: 'First Responder',
  infectious_disease: 'Infectious Disease',
  medical_administration: 'Medical Administration',
  medical_education_training: 'Medical Education & Training',
  medical_research: 'Medical Research',
  medicine: 'Medicine',
  neurology: 'Neurology',
  nursing: 'Nursing',
  nutrition_dietetics: 'Nutrition & Dietetics',
  obstetrics_gynecology: 'Obstetrics / Gynecology',
  oncology: 'Oncology',
  opthalmology: 'Opthalmology',
  optometry: 'Optometry',
  orthopedics: 'Orthopedics',
  pathology: 'Pathology',
  pediatrics: 'Pediatrics',
  pharmacy: 'Pharmacy',
  physical_therapy: 'Physical Therapy',
  psychiatry: 'Psychiatry',
  psychology: 'Psychology',
  public_health: 'Public Health',
  radiology: 'Radiology',
  social_work: 'Social Work',
  call_center: 'Call Center',
  construction: 'Construction',
  corporate_strategy: 'Corporate Strategy',
  customer_service_support: 'Customer Service / Support',
  enterprise_resource_planning: 'Enterprise Resource Planning',
  facilities_management: 'Facilities Management',
  leasing: 'Leasing',
  logistics: 'Logistics',
  office_operations: 'Office Operations',
  operations: 'Operations',
  physical_security: 'Physical Security',
  project_development: 'Project Development',
  quality_management: 'Quality Management',
  real_estate: 'Real Estate',
  safety: 'Safety',
  store_operations: 'Store Operations',
  supply_chain: 'Supply Chain',
  account_management: 'Account Management',
  business_development: 'Business Development',
  channel_sales: 'Channel Sales',
  customer_retention_development: 'Customer Retention & Development',
  customer_success: 'Customer Success',
  field_outside_sales: 'Field / Outside Sales',
  inside_sales: 'Inside Sales',
  partnerships: 'Partnerships',
  revenue_operations: 'Revenue Operations',
  sales: 'Sales',
  sales_enablement: 'Sales Enablement',
  sales_engineering: 'Sales Engineering',
  sales_operations: 'Sales Operations',
  sales_training: 'Sales Training',
  consulting: 'Consulting',
};

export const DesignationKeys: any = {
  founder: 'Founder',
  c_suite: 'C suite',
  partner: 'Partner',
  vp: 'Vp',
  head: 'Head',
  director: 'Director',
  manager: 'Manager',
  senior: 'Senior',
  entry: 'Entry',
  intern: 'Intern',
};

export const ColumnTitles: Record<string, string> = {
  company: 'Company',
  location: 'Location',
  accountHQLocation: 'Account Location',
  industry: 'Industry',
  employeeByDepartment: 'Employee By Dept.',
  companyKeyword: 'Company keyword',
  totalEmployeeCount: 'Employee Count',
  revenue: 'Revenue',
  technology: 'Technology',
  funding: 'Funding',
  stages: 'Latest Funding Stage',
  lastFundingDate: 'Latest Funding Date',
  lastFundingAmount: 'Latest Funding Amount',
  foundedYear: 'Founded Year',
  retailLocation: 'Retail locations',
  contactLocation: 'Contact Location',
  jobTitle: 'Job Title',
  catalogerDivisions: 'Department',
  catalogerDesignations: 'Seniority',
  totalFunding: 'Total Funding Amount',
  jobLastChange: 'Last Job Changed',
  changedLastDays: 'Last Job Changed',
  sic: 'Industry SIC Code',
  naics: 'Industry NAICS Code',
  contactName: 'Contact Name',
  title: 'Hiring for',
  seniority: 'Hiring Seniority Level',
  posted_date: 'Job Posted Date',
};

export const CREDITS_POLLING_INTERVAL = 60000; // 60 seconds

export const employeByDepartmentHash: Record<string, string> = {
  accounting: 'Accounting',
  administrative: 'Administrative',
  arts_and_design: 'Design',
  business_development: 'Business Development',
  consulting: 'Consulting',
  data_science: 'Data Science',
  education: 'Education',
  engineering: 'Engineering & Technical',
  entrepreneurship: 'Entrepreneurship',
  finance: 'Financial',
  human_resources: 'Human Resources',
  information_technology: 'Information Technology',
  legal: 'Legal',
  marketing: 'Marketing',
  media_and_communication: 'Media & Communications',
  operations: 'Operations',
  product_management: 'Product Management',
  sales: 'Sales',
  support: 'Support',
  customer_service: 'Customer Support',
  public_relations: 'Public Relations',
  trades: 'Trades',
  health: 'Community and Social Services',
  real_estate: 'Real Estate',
  other_uncategorized: 'Others',
};

export const employeeByDeptESHash: Record<string, string> = {
  acc: 'Accounting',
  adm: 'Administrative',
  des: 'Design',
  bd: 'Business Development',
  cass: 'Community And Social Services',
  con: 'Consulting',
  edu: 'Education',
  eng: 'Engineering',
  ent: 'Entrepreneurship',
  fin: 'Finance',
  hr: 'Human Resources',
  it: 'Information Technology',
  leg: 'Legal',
  mkt: 'Marketing',
  med_com: 'Media and Communication',
  med_hel: 'Medical And Health',
  mil_pro_ser: 'Military And Protection Services',
  ops: 'Operations',
  others: 'Others',
  prod: 'Product',
  proj_mgmt: 'Program and Project Management',
  pur: 'Purchasing',
  qc: 'Quality Control',
  re: 'Real Estate',
  res: 'Research',
  sales: 'Sales',
  support: 'Support',
};

export const employeeByDeptESHashV2: Record<string, string> = {
    gm: 'General Management',
    sal: 'Sales',
    mkt: 'Marketing',
    rev: 'Revenue Operations',
    css: 'Customer Success & Support',
    pro: 'Product',
    des: 'Design / UX',
    eng: 'Engineering / Software',
    daa: 'Data, Analytics & AI',
    it: 'IT & Infrastructure',
    sec: 'Security',
    fin: 'Finance',
    hr: 'Human Resources / People',
    leg: 'Legal, Risk & Compliance',
    ops: 'Operations',
    scl: 'Supply Chain & Logistics',
    mh: 'Medical & Health',
    edu: 'Education',
    con: 'Consulting / Professional Services',
    rnd: 'Research & Development / Science',
    ref: 'Real Estate & Facilities',
    stf: 'Skilled Trades & Field Services',
  };

export const WITHOUT_STATE_US_METRO_REGIONS = [
  'Anchorage::city',
  'Fairbanks::city',
  'Anniston::city',
  'Birmingham::city',
  'Dothan::city',
  'Huntsville::city',
  'Mobile::city',
  'Montgomery::city',
  'Tuscaloosa::city',
  'Fort Smith::city',
  'Jonesboro::city',
  'Little Rock::city',
  'Phoenix::city',
  'Tucson::city',
  'Yuma::city',
  'Bakersfield::city',
  'Chico::city',
  'Eureka::city',
  'Fresno::city',
  'Irvine::city',
  'Los Angeles::city',
  'Monterey Bay::city',
  'Palm Springs::city',
  'Sacramento::city',
  'San Diego::city',
  'San Francisco::city',
  'San Jose::city',
  'Santa Barbara::city',
  'Colorado Springs::city',
  'Denver::city',
  'Grand Junction::city',
  'Hartford::city',
  'Fort Myers::city',
  'Gainesville::city',
  'Jacksonville::city',
  'Miami::city',
  'Orlando::city',
  'Panama City::city',
  'Tallahassee::city',
  'Tampa Bay::city',
  'West Palm Beach::city',
  'Albany::city',
  'Atlanta::city',
  'Augusta::city',
  'Columbus::city',
  'Macon::city',
  'Savannah::city',
  'Honolulu::city',
  'Cedar Rapids::city',
  'Davenport::city',
  'Des Moines::city',
  'Ottumwa::city',
  'Sioux City::city',
  'Boise City::city',
  'Idaho Falls::city',
  'Twin Falls::city',
  'Chicago::city',
  'Peoria::city',
  'Quincy::city',
  'Rockford::city',
  'Springfield::city',
  'Evansville::city',
  'Fort Wayne::city',
  'Indianapolis::city',
  'Lafayette::city',
  'South Bend::city',
  'Terre Haute::city',
  'Topeka::city',
  'Wichita::city',
  'Bowling Green::city',
  'Lexington::city',
  'Louisville::city',
  'Paducah::city',
  'Alexandria::city',
  'Baton Rouge::city',
  'Lake Charles::city',
  'Monroe::city',
  'New Orleans::city',
  'Shreveport::city',
  'Boston::city',
  'Baltimore::city',
  'Salisbury::city',
  'Bangor::city',
  'Portland::city',
  'PresqueIsle::city',
  'Alpena::city',
  'Detroit::city',
  'Flint::city',
  'Grand Rapids::city',
  'Lansing::city',
  'Marquette::city',
  'Traverse City::city',
  'Duluth::city',
  'Mankato::city',
  'Minneapolis::city',
  'Rochester::city',
  'Jefferson City::city',
  'Joplin::city',
  'Kansas City::city',
  'Saint Joseph::city',
  'Saint Louis::city',
  'Biloxi::city',
  'Greenville::city',
  'Hattiesburg::city',
  'Jackson::city',
  'Meridian::city',
  'Billings::city',
  'Butte::city',
  'Glendive::city',
  'Great Falls::city',
  'Helena::city',
  'Missoula::city',
  'Charlotte::city',
  'Raleigh::city',
  'Wilmington::city',
  'Winston Salem::city',
  'Bismarck::city',
  'Fargo::city',
  'Lincoln::city',
  'North Platte::city',
  'Omaha::city',
  'Albuquerque::city',
  'Las Vegas::city',
  'Reno::city',
  'Binghamton::city',
  'Buffalo::city',
  'Elmira::city',
  'Syracuse::city',
  'Utica::city',
  'Watertown::city',
  'Cincinnati::city',
  'Cleveland::city',
  'Dayton::city',
  'Lima::city',
  'Toledo::city',
  'Wheeling::city',
  'Youngstown::city',
  'Zanesville::city',
  'Ardmore::city',
  'Oklahoma City::city',
  'Tulsa::city',
  'Bend::city',
  'Eugene::city',
  'Medford::city',
  'Erie::city',
  'Harrisburg::city',
  'Johnstown::city',
  'Philadelphia::city',
  'Pittsburgh::city',
  'Wilkes Barre::city',
  'Aguadilla::city',
  'Mayaguez::city',
  'Ponce::city',
  'San Juan::city',
  'Providence::city',
  'Charleston::city',
  'Columbia::city',
  'Florence::city',
  'Rapid City::city',
  'Sioux Falls::city',
  'Chattanooga::city',
  'Knoxville::city',
  'Memphis::city',
  'Nashville::city',
  'Tri Cities::city',
  'Abilene::city',
  'Amarillo::city',
  'Austin::city',
  'Beaumont::city',
  'Bryan::city',
  'Corpus Christi::city',
  'Dallas::city',
  'El Paso::city',
  'Harlingen::city',
  'Houston::city',
  'Laredo::city',
  'Lubbock::city',
  'Odessa::city',
  'San Angelo::city',
  'San Antonio::city',
  'Tyler::city',
  'Victoria::city',
  'Wichita Falls::city',
  'Salt Lake City::city',
  'Charlottesville::city',
  'Hampton Roads::city',
  'Harrisonburg::city',
  'Richmond::city',
  'Roanoke::city',
  'Burlington::city',
  'Seattle::city',
  'Spokane::city',
  'Green Bay::city',
  'La Crosse::city',
  'Madison::city',
  'Milwaukee::city',
  'Wausau::city',
  'Bluefield::city',
  'Clarksburg::city',
  'Parkersburg::city',
  'Casper::city',
  'Cheyenne::city',
];
export const WITHOUT_STATE_US_METRO_REGIONS_CLEAN = [
  'Anchorage',
  'Fairbanks',
  'Anniston',
  'Birmingham',
  'Dothan',
  'Huntsville',
  'Mobile',
  'Montgomery',
  'Tuscaloosa',
  'Fort Smith',
  'Jonesboro',
  'Little Rock',
  'Phoenix',
  'Tucson',
  'Yuma',
  'Bakersfield',
  'Chico',
  'Eureka',
  'Fresno',
  'Irvine',
  'Los Angeles',
  'Monterey Bay',
  'Palm Springs',
  'Sacramento',
  'San Diego',
  'San Francisco',
  'San Jose',
  'Santa Barbara',
  'Colorado Springs',
  'Denver',
  'Grand Junction',
  'Hartford',
  'Fort Myers',
  'Gainesville',
  'Jacksonville',
  'Miami',
  'Orlando',
  'Panama City',
  'Tallahassee',
  'Tampa Bay',
  'West Palm Beach',
  'Albany',
  'Atlanta',
  'Augusta',
  'Columbus',
  'Macon',
  'Savannah',
  'Honolulu',
  'Cedar Rapids',
  'Davenport',
  'Des Moines',
  'Ottumwa',
  'Sioux City',
  'Boise City',
  'Idaho Falls',
  'Twin Falls',
  'Chicago',
  'Peoria',
  'Quincy',
  'Rockford',
  'Springfield',
  'Evansville',
  'Fort Wayne',
  'Indianapolis',
  'Lafayette',
  'South Bend',
  'Terre Haute',
  'Topeka',
  'Wichita',
  'Bowling Green',
  'Lexington',
  'Louisville',
  'Paducah',
  'Alexandria',
  'Baton Rouge',
  'Lake Charles',
  'Monroe',
  'New Orleans',
  'Shreveport',
  'Boston',
  'Baltimore',
  'Salisbury',
  'Bangor',
  'Portland',
  'PresqueIsle',
  'Alpena',
  'Detroit',
  'Flint',
  'Grand Rapids',
  'Lansing',
  'Marquette',
  'Traverse City',
  'Duluth',
  'Mankato',
  'Minneapolis',
  'Rochester',
  'Jefferson City',
  'Joplin',
  'Kansas City',
  'Saint Joseph',
  'Saint Louis',
  'Biloxi',
  'Greenville',
  'Hattiesburg',
  'Jackson',
  'Meridian',
  'Billings',
  'Butte',
  'Glendive',
  'Great Falls',
  'Helena',
  'Missoula',
  'Charlotte',
  'Raleigh',
  'Wilmington',
  'Winston Salem',
  'Bismarck',
  'Fargo',
  'Lincoln',
  'North Platte',
  'Omaha',
  'Albuquerque',
  'Las Vegas',
  'Reno',
  'Binghamton',
  'Buffalo',
  'Elmira',
  'Syracuse',
  'Utica',
  'Watertown',
  'Cincinnati',
  'Cleveland',
  'Dayton',
  'Lima',
  'Toledo',
  'Wheeling',
  'Youngstown',
  'Zanesville',
  'Ardmore',
  'Oklahoma City',
  'Tulsa',
  'Bend',
  'Eugene',
  'Medford',
  'Erie',
  'Harrisburg',
  'Johnstown',
  'Philadelphia',
  'Pittsburgh',
  'Wilkes Barre',
  'Aguadilla',
  'Mayaguez',
  'Ponce',
  'San Juan',
  'Providence',
  'Charleston',
  'Columbia',
  'Florence',
  'Rapid City',
  'Sioux Falls',
  'Chattanooga',
  'Knoxville',
  'Memphis',
  'Nashville',
  'Tri Cities',
  'Abilene',
  'Amarillo',
  'Austin',
  'Beaumont',
  'Bryan',
  'Corpus Christi',
  'Dallas',
  'El Paso',
  'Harlingen',
  'Houston',
  'Laredo',
  'Lubbock',
  'Odessa',
  'San Angelo',
  'San Antonio',
  'Tyler',
  'Victoria',
  'Wichita Falls',
  'Salt Lake City',
  'Charlottesville',
  'Hampton Roads',
  'Harrisonburg',
  'Richmond',
  'Roanoke',
  'Burlington',
  'Seattle',
  'Spokane',
  'Green Bay',
  'La Crosse',
  'Madison',
  'Milwaukee',
  'Wausau',
  'Bluefield',
  'Clarksburg',
  'Parkersburg',
  'Casper',
  'Cheyenne',
];
export const WITHOUT_STATE_CA_METRO_REGIONS = [
  'Calgary::city',
  'Edmonton::city',
  'Abbotsford::city',
  'Kelowna::city',
  'Vancouver::city',
  'Winnipeg::city',
  'Moncton::city',
  'St. John::city',
  'Halifax::city',
  'Barrie::city',
  'Brantford::city',
  'Guelph::city',
  'Hamilton::city',
  'Kingston::city',
  'Kitchener::city',
  'London::city',
  'Ottawa::city',
  'Peterborough::city',
  'St. Catherines::city',
  'Sudbury::city',
  'Thunder Bay::city',
  'Toronto::city',
  'Windsor::city',
  'Charlottetown::city',
  'Chicoutimi::city',
  'Montreal::city',
  'Sherbrooke::city',
  'Trois Rivieres::city',
  'Regina::city',
  'Saskatoon::city',
  'Yellowknife::city',
];
export const WITHOUT_STATE_CA_METRO_REGIONS_CLEAN = [
  'Calgary',
  'Edmonton',
  'Abbotsford',
  'Kelowna',
  'Vancouver',
  'Winnipeg',
  'Moncton',
  'St. John',
  'Halifax',
  'Barrie',
  'Brantford',
  'Guelph',
  'Hamilton',
  'Kingston',
  'Kitchener',
  'London',
  'Ottawa',
  'Peterborough',
  'St. Catherines',
  'Sudbury',
  'Thunder Bay',
  'Toronto',
  'Windsor',
  'Charlottetown',
  'Chicoutimi',
  'Montreal',
  'Sherbrooke',
  'Trois Rivieres',
  'Regina',
  'Saskatoon',
  'Yellowknife',
];
export const regionalData = {
  'US - States': [
    'Alabama::state',
    'Alaska::state',
    'Arizona::state',
    'Arkansas::state',
    'California::state',
    'Colorado::state',
    'Connecticut::state',
    'Delaware::state',
    'District of Columbia::state',
    'FL-Florida::state',
    'Georgia::state',
    'Hawaii::state',
    'Idaho::state',
    'Illinois::state',
    'Indiana::state',
    'Iowa::state',
    'Kansas::state',
    'Kentucky::state',
    'Louisiana::state',
    'Maine::state',
    'MD-Maryland::state',
    'Massachusetts::state',
    'Michigan::state',
    'Minnesota::state',
    'Mississippi::state',
    'Missouri::state',
    'MT-Montana::state',
    'Nebraska::state',
    'Nevada::state',
    'New Hampshire::state',
    'New Jersey::state',
    'New Mexico::state',
    'New York::state',
    'North Carolina::state',
    'North Dakota::state',
    'Ohio::state',
    'Oklahoma::state',
    'Oregon::state',
    'Pennsylvania::state',
    'Rhode Island::state',
    'South Carolina::state',
    'South Dakota::state',
    'Tennessee::state',
    'Texas::state',
    'Utah::state',
    'Vermont::state',
    'Virginia::state',
    'Washington::state',
    'West Virginia::state',
    'Wisconsin::state',
    'Wyoming::state',
    'American Samoa::state',
    'Canal Zone::state',
    'Guam::state',
    'Puerto Rico::state',
    'Virgin Islands::state',
  ],
  'US - Metro Regions': [
    'AK-Anchorage::city',
    'AK-Fairbanks::city',
    'AL-Anniston::city',
    'AL-Birmingham::city',
    'AL-Dothan::city',
    'AL-Huntsville::city',
    'AL-Mobile::city',
    'AL-Montgomery::city',
    'AL-Tuscaloosa::city',
    'AR-Fort Smith::city',
    'AR-Jonesboro::city',
    'AR-Little Rock::city',
    'AZ-Phoenix::city',
    'AZ-Tucson::city',
    'AZ-Yuma::city',
    'CA-Bakersfield::city',
    'CA-Chico::city',
    'CA-Eureka::city',
    'CA-Fresno::city',
    'CA-Irvine::city',
    'CA-Los Angeles::city',
    'CA-Monterey Bay::city',
    'CA-Palm Springs::city',
    'CA-Sacramento::city',
    'CA-San Diego::city',
    'CA-San Francisco::city',
    'CA-San Jose::city',
    'CA-Santa Barbara::city',
    'CO-Colorado Springs::city',
    'CO-Denver::city',
    'CO-Grand Junction::city',
    'CT-Hartford::city',
    'FL-Fort Myers::city',
    'FL-Gainesville::city',
    'FL-Jacksonville::city',
    'FL-Miami::city',
    'FL-Orlando::city',
    'FL-Panama City::city',
    'FL-Tallahassee::city',
    'FL-Tampa Bay::city',
    'FL-West Palm Beach::city',
    'GA-Albany::city',
    'GA-Atlanta::city',
    'GA-Augusta::city',
    'GA-Columbus::city',
    'GA-Macon::city',
    'GA-Savannah::city',
    'HI-Honolulu::city',
    'IA-Cedar Rapids::city',
    'IA-Davenport::city',
    'IA-Des Moines::city',
    'IA-Ottumwa::city',
    'IA-Sioux City::city',
    'ID-Boise City::city',
    'ID-Idaho Falls::city',
    'ID-Twin Falls::city',
    'IL-Chicago::city',
    'IL-Peoria::city',
    'IL-Quincy::city',
    'IL-Rockford::city',
    'IL-Springfield::city',
    'IN-Evansville::city',
    'IN-Fort Wayne::city',
    'IN-Indianapolis::city',
    'IN-Lafayette::city',
    'IN-South Bend::city',
    'IN-Terre Haute::city',
    'KS-Topeka::city',
    'KS-Wichita::city',
    'KY-Bowling Green::city',
    'KY-Lexington::city',
    'KY-Louisville::city',
    'KY-Paducah::city',
    'LA-Alexandria::city',
    'LA-Baton Rouge::city',
    'LA-Lake Charles::city',
    'LA-Monroe::city',
    'LA-New Orleans::city',
    'LA-Shreveport::city',
    'MA-Boston::city',
    'MD-Baltimore::city',
    'MD-Salisbury::city',
    'ME-Bangor::city',
    'ME-Portland::city',
    'ME-PresqueIsle::city',
    'MI-Alpena::city',
    'MI-Detroit::city',
    'MI-Flint::city',
    'MI-Grand Rapids::city',
    'MI-Lansing::city',
    'MI-Marquette::city',
    'MI-Traverse City::city',
    'MN-Duluth::city',
    'MN-Mankato::city',
    'MN-Minneapolis::city',
    'MN-Rochester::city',
    'MO-Jefferson City::city',
    'MO-Joplin::city',
    'MO-Kansas City::city',
    'MO-Saint Joseph::city',
    'MO-Saint Louis::city',
    'MS-Biloxi::city',
    'MS-Greenville::city',
    'MS-Hattiesburg::city',
    'MS-Jackson::city',
    'MS-Meridian::city',
    'MT-Billings::city',
    'MT-Butte::city',
    'MT-Glendive::city',
    'MT-Great Falls::city',
    'MT-Helena::city',
    'MT-Missoula::city',
    'NC-Charlotte::city',
    'NC-Raleigh::city',
    'NC-Wilmington::city',
    'NC-Winston Salem::city',
    'ND-Bismarck::city',
    'ND-Fargo::city',
    'NE-Lincoln::city',
    'NE-North Platte::city',
    'NE-Omaha::city',
    'NM-Albuquerque::city',
    'NV-Las Vegas::city',
    'NV-Reno::city',
    'NY-Binghamton::city',
    'NY-Buffalo::city',
    'NY-Elmira::city',
    'NY-Syracuse::city',
    'NY-Utica::city',
    'NY-Watertown::city',
    'OH-Cincinnati::city',
    'OH-Cleveland::city',
    'OH-Dayton::city',
    'OH-Lima::city',
    'OH-Toledo::city',
    'OH-Wheeling::city',
    'OH-Youngstown::city',
    'OH-Zanesville::city',
    'OK-Ardmore::city',
    'OK-Oklahoma City::city',
    'OK-Tulsa::city',
    'OR-Bend::city',
    'OR-Eugene::city',
    'OR-Medford::city',
    'PA-Erie::city',
    'PA-Harrisburg::city',
    'PA-Johnstown::city',
    'PA-Philadelphia::city',
    'PA-Pittsburgh::city',
    'PA-Wilkes Barre::city',
    'PR-Aguadilla::city',
    'PR-Mayaguez::city',
    'PR-Ponce::city',
    'PR-San Juan::city',
    'RI-Providence::city',
    'SC-Charleston::city',
    'SC-Columbia::city',
    'SC-Florence::city',
    'SD-Rapid City::city',
    'SD-Sioux Falls::city',
    'TN-Chattanooga::city',
    'TN-Knoxville::city',
    'TN-Memphis::city',
    'TN-Nashville::city',
    'TN-Tri Cities::city',
    'TX-Abilene::city',
    'TX-Amarillo::city',
    'TX-Austin::city',
    'TX-Beaumont::city',
    'TX-Bryan::city',
    'TX-Corpus Christi::city',
    'TX-Dallas::city',
    'TX-El Paso::city',
    'TX-Harlingen::city',
    'TX-Houston::city',
    'TX-Laredo::city',
    'TX-Lubbock::city',
    'TX-Odessa::city',
    'TX-San Angelo::city',
    'TX-San Antonio::city',
    'TX-Tyler::city',
    'TX-Victoria::city',
    'TX-Wichita Falls::city',
    'UT-Salt Lake City::city',
    'VA-Charlottesville::city',
    'VA-Hampton Roads::city',
    'VA-Harrisonburg::city',
    'VA-Richmond::city',
    'VA-Roanoke::city',
    'VT-Burlington::city',
    'WA-Seattle::city',
    'WA-Spokane::city',
    'WI-Green Bay::city',
    'WI-La Crosse::city',
    'WI-Madison::city',
    'WI-Milwaukee::city',
    'WI-Wausau::city',
    'WV-Bluefield::city',
    'WV-Clarksburg::city',
    'WV-Parkersburg::city',
    'WY-Casper::city',
    'WY-Cheyenne::city',
  ],
  'CA - Provinces': [
    'Alberta::state',
    'British Columbia::state',
    'Manitoba::state',
    'New Brunswick::state',
    'Newfoundland::state',
    'Northwest Territories::state',
    'Nova Scotia::state',
    'Nunavut::state',
    'Ontario::state',
    'Prince Edward Island::state',
    'Quebec::state',
    'Saskatchewan::state',
    'Yukon::state',
  ],
  'CA - Metro Regions': [
    'AB-Calgary::city',
    'AB-Edmonton::city',
    'BC-Abbotsford::city',
    'BC-Kelowna::city',
    'BC-Vancouver::city',
    'MB-Winnipeg::city',
    'NB-Moncton::city',
    'NB-St. John::city',
    'NS-Halifax::city',
    'ON-Barrie::city',
    'ON-Brantford::city',
    'ON-Guelph::city',
    'ON-Hamilton::city',
    'ON-Kingston::city',
    'ON-Kitchener::city',
    'ON-London::city',
    'ON-Ottawa::city',
    'ON-Peterborough::city',
    'ON-St. Catherines::city',
    'ON-Sudbury::city',
    'ON-Thunder Bay::city',
    'ON-Toronto::city',
    'ON-Windsor::city',
    'PEI-Charlottetown::city',
    'QC-Chicoutimi::city',
    'QC-Montreal::city',
    'QC-Sherbrooke::city',
    'QC-Trois Rivieres::city',
    'SK-Regina::city',
    'SK-Saskatoon::city',
    'YT-Yellowknife::city',
  ],
  Africa: [
    'Algeria::country',
    'Angola::country',
    'Benin::country',
    'Botswana::country',
    'Burkina Faso::country',
    'Burundi::country',
    'Cameroon::country',
    'Cape Verde::country',
    'Central African Republic::country',
    'Chad::country',
    'Comoros::country',
    'Congo (DRC)::country',
    'Congo (Republic)::country',
    'Djibouti::country',
    'Egypt::country',
    'Equatorial Guinea::country',
    'Eritrea::country',
    'Ethiopia::country',
    'Gabon::country',
    'Gambia::country',
    'Ghana::country',
    'Guinea::country',
    'Guinea-Bissau::country',
    'Kenya::country',
    'Lesotho::country',
    'Liberia::country',
    'Libya::country',
    'Madagascar::country',
    'Malawi::country',
    'Mali::country',
    'Mauritania::country',
    'Mauritius::country',
    'Morocco::country',
    'Mozambique::country',
    'Namibia::country',
    'Niger::country',
    'Nigeria::country',
    'Rwanda::country',
    'Sao Tome and Principe::country',
    'Senegal::country',
    'Seychelles::country',
    'Sierra Leone::country',
    'Somalia::country',
    'South Africa::country',
    'Sudan::country',
    'Swaziland::country',
    'Tanzania::country',
    'Togo::country',
    'Tunisia::country',
    'Uganda::country',
    'Zambia::country',
    'Zimbabwe::country',
    'Cabo Verde::country',
    "Côte d'Ivoire::country",
    'Eswatini::country',
    'French Southern Territories::country',
    'Mayotte::country',
    'Réunion::country',
    'Saint Helena, Ascension and Tristan da Cunha::country',
    'South Sudan::country',
    'Western Sahara::country',
  ],
  Asia: [
    'Afghanistan::country',
    'Armenia::country',
    'Azerbaijan::country',
    'Bahrain::country',
    'Bangladesh::country',
    'Bhutan::country',
    'Brunei Darussalam::country',
    'Cambodia::country',
    'China::country',
    'India::country',
    'Indonesia::country',
    'Iran::country',
    'Israel::country',
    'Japan::country',
    'Jordan::country',
    'Kazakhstan::country',
    'Kuwait::country',
    'Kyrgyzstan::country',
    'Laos::country',
    'Lebanon::country',
    'Malaysia::country',
    'Maldives::country',
    'Mongolia::country',
    'Myanmar::country',
    'Nepal::country',
    'North Korea::country',
    'Oman::country',
    'Pakistan::country',
    'Philippines::country',
    'Qatar::country',
    'Saudi Arabia::country',
    'Singapore::country',
    'South Korea::country',
    'Sri Lanka::country',
    'Syria::country',
    'Taiwan::country',
    'Tajikistan::country',
    'Thailand::country',
    'Turkey::country',
    'Turkmenistan::country',
    'United Arab Emirates::country',
    'Uzbekistan::country',
    'Vietnam::country',
    'Yemen::country',
    'British Indian Ocean Territory::country',
    'Christmas Island::country',
    'Cocos Islands::country',
    'Hong Kong::country',
    'Iraq::country',
    'Macao::country',
    'Palestine::country',
  ],
  'Eastern Europe': [
    'Albania::country',
    'Belarus::country',
    'Bosnia Herzegovina::country',
    'Bulgaria::country',
    'Czech Republic::country',
    'Hungary::country',
    'Macedonia (FYROM)::country',
    'Moldova::country',
    'Poland::country',
    'Romania::country',
    'Russia::country',
    'Slovakia::country',
    'Ukraine::country',
    'Bosnia and Herzegovina::country',
    'Czechia::country',
    'Russian Federation::country',
  ],
  'Western Europe': [
    'Austria::country',
    'Belgium::country',
    'France::country',
    'Germany::country',
    'Liechtenstein::country',
    'Luxembourg::country',
    'Monaco::country',
    'Netherlands::country',
    'Switzerland::country',
    'Gibraltar::country',
  ],
  'Southern Europe': [
    'Andorra::country',
    'Croatia::country',
    'Cyprus::country',
    'Greece::country',
    'Italy::country',
    'Malta::country',
    'Portugal::country',
    'San Marino::country',
    'Slovenia::country',
    'Spain::country',
    'Holy See::country',
    'Montenegro::country',
    'North Macedonia::country',
    'Serbia::country',
  ],
  'Northern Europe': [
    'Denmark::country',
    'Estonia::country',
    'Finland::country',
    'Iceland::country',
    'Ireland::country',
    'Latvia::country',
    'Lithuania::country',
    'Norway::country',
    'Sweden::country',
    'United Kingdom::country',
    'Åland Islands::country',
    'Faroe Islands::country',
    'Guernsey::country',
    'Isle of Man::country',
    'Jersey::country',
    'Svalbard and Jan Mayen::country',
  ],
  'North America': [
    'Antigua and Barbuda::country',
    'Bahamas::country',
    'Barbados::country',
    'Belize::country',
    'Canada::country',
    'Costa Rica::country',
    'Cuba::country',
    'Dominica::country',
    'Dominican Republic::country',
    'El Salvador::country',
    'Grenada::country',
    'Guatemala::country',
    'Haiti::country',
    'Honduras::country',
    'Jamaica::country',
    'Mexico::country',
    'Nicaragua::country',
    'Panama::country',
    'Saint Kitts and Nevis::country',
    'Saint Vincent and the Grenadines::country',
    'Trinidad and Tobago::country',
    'United States::country',
    'Anguilla::country',
    'Aruba::country',
    'Bonaire, Sint Eustatius and Saba::country',
    'Cayman Islands::country',
    'Curaçao::country',
    'Greenland::country',
    'Guadeloupe::country',
    'Martinique::country',
    'Montserrat::country',
    'Saint Barthélemy::country',
    'Saint Lucia::country',
    'Saint Martin::country',
    'Saint Pierre and Miquelon::country',
    'Sint Maarten::country',
    'Turks and Caicos Islands::country',
  ],
  'South America': [
    'Argentina::country',
    'Bolivia::country',
    'Brazil::country',
    'Chile::country',
    'Colombia::country',
    'Ecuador::country',
    'Guyana::country',
    'Paraguay::country',
    'Peru::country',
    'Suriname::country',
    'Uruguay::country',
    'Venezuela::country',
    'Falkland Islands::country',
    'French Guiana::country',
    'South Georgia and the South Sandwich Islands::country',
  ],
  Oceania: [
    'Australia::country',
    'Cook Islands::country',
    'Fiji::country',
    'Kiribati::country',
    'New Zealand::country',
    'Papua New Guinea::country',
    'Samoa::country',
    'Solomon Islands::country',
    'Timor-Leste::country',
    'Tonga::country',
    'Vanuatu::country',
    'French Polynesia::country',
    'Heard Island and McDonald Islands::country',
    'Marshall Islands::country',
    'Micronesia::country',
    'Nauru::country',
    'New Caledonia::country',
    'Niue::country',
    'Norfolk Island::country',
    'Northern Mariana Islands::country',
    'Palau::country',
    'Pitcairn::country',
    'Tokelau::country',
    'Tuvalu::country',
    'United States Minor Outlying Islands::country',
    'Wallis and Futuna::country',
  ],
};
export const cleanedRegionalData = {
  'US - States': [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District of Columbia',
    'FL-Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'MD-Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'MT-Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
    'American Samoa',
    'Canal Zone',
    'Guam',
    'Puerto Rico',
    'Virgin Islands',
  ],
  'US - Metro Regions': [
    'AK-Anchorage',
    'AK-Fairbanks',
    'AL-Anniston',
    'AL-Birmingham',
    'AL-Dothan',
    'AL-Huntsville',
    'AL-Mobile',
    'AL-Montgomery',
    'AL-Tuscaloosa',
    'AR-Fort Smith',
    'AR-Jonesboro',
    'AR-Little Rock',
    'AZ-Phoenix',
    'AZ-Tucson',
    'AZ-Yuma',
    'CA-Bakersfield',
    'CA-Chico',
    'CA-Eureka',
    'CA-Fresno',
    'CA-Irvine',
    'CA-Los Angeles',
    'CA-Monterey Bay',
    'CA-Palm Springs',
    'CA-Sacramento',
    'CA-San Diego',
    'CA-San Francisco',
    'CA-San Jose',
    'CA-Santa Barbara',
    'CO-Colorado Springs',
    'CO-Denver',
    'CO-Grand Junction',
    'CT-Hartford',
    'FL-Fort Myers',
    'FL-Gainesville',
    'FL-Jacksonville',
    'FL-Miami',
    'FL-Orlando',
    'FL-Panama City',
    'FL-Tallahassee',
    'FL-Tampa Bay',
    'FL-West Palm Beach',
    'GA-Albany',
    'GA-Atlanta',
    'GA-Augusta',
    'GA-Columbus',
    'GA-Macon',
    'GA-Savannah',
    'HI-Honolulu',
    'IA-Cedar Rapids',
    'IA-Davenport',
    'IA-Des Moines',
    'IA-Ottumwa',
    'IA-Sioux City',
    'ID-Boise City',
    'ID-Idaho Falls',
    'ID-Twin Falls',
    'IL-Chicago',
    'IL-Peoria',
    'IL-Quincy',
    'IL-Rockford',
    'IL-Springfield',
    'IN-Evansville',
    'IN-Fort Wayne',
    'IN-Indianapolis',
    'IN-Lafayette',
    'IN-South Bend',
    'IN-Terre Haute',
    'KS-Topeka',
    'KS-Wichita',
    'KY-Bowling Green',
    'KY-Lexington',
    'KY-Louisville',
    'KY-Paducah',
    'LA-Alexandria',
    'LA-Baton Rouge',
    'LA-Lake Charles',
    'LA-Monroe',
    'LA-New Orleans',
    'LA-Shreveport',
    'MA-Boston',
    'MD-Baltimore',
    'MD-Salisbury',
    'ME-Bangor',
    'ME-Portland',
    'ME-PresqueIsle',
    'MI-Alpena',
    'MI-Detroit',
    'MI-Flint',
    'MI-Grand Rapids',
    'MI-Lansing',
    'MI-Marquette',
    'MI-Traverse City',
    'MN-Duluth',
    'MN-Mankato',
    'MN-Minneapolis',
    'MN-Rochester',
    'MO-Jefferson City',
    'MO-Joplin',
    'MO-Kansas City',
    'MO-Saint Joseph',
    'MO-Saint Louis',
    'MS-Biloxi',
    'MS-Greenville',
    'MS-Hattiesburg',
    'MS-Jackson',
    'MS-Meridian',
    'MT-Billings',
    'MT-Butte',
    'MT-Glendive',
    'MT-Great Falls',
    'MT-Helena',
    'MT-Missoula',
    'NC-Charlotte',
    'NC-Raleigh',
    'NC-Wilmington',
    'NC-Winston Salem',
    'ND-Bismarck',
    'ND-Fargo',
    'NE-Lincoln',
    'NE-North Platte',
    'NE-Omaha',
    'NM-Albuquerque',
    'NV-Las Vegas',
    'NV-Reno',
    'NY-Binghamton',
    'NY-Buffalo',
    'NY-Elmira',
    'NY-Syracuse',
    'NY-Utica',
    'NY-Watertown',
    'OH-Cincinnati',
    'OH-Cleveland',
    'OH-Dayton',
    'OH-Lima',
    'OH-Toledo',
    'OH-Wheeling',
    'OH-Youngstown',
    'OH-Zanesville',
    'OK-Ardmore',
    'OK-Oklahoma City',
    'OK-Tulsa',
    'OR-Bend',
    'OR-Eugene',
    'OR-Medford',
    'PA-Erie',
    'PA-Harrisburg',
    'PA-Johnstown',
    'PA-Philadelphia',
    'PA-Pittsburgh',
    'PA-Wilkes Barre',
    'PR-Aguadilla',
    'PR-Mayaguez',
    'PR-Ponce',
    'PR-San Juan',
    'RI-Providence',
    'SC-Charleston',
    'SC-Columbia',
    'SC-Florence',
    'SD-Rapid City',
    'SD-Sioux Falls',
    'TN-Chattanooga',
    'TN-Knoxville',
    'TN-Memphis',
    'TN-Nashville',
    'TN-Tri Cities',
    'TX-Abilene',
    'TX-Amarillo',
    'TX-Austin',
    'TX-Beaumont',
    'TX-Bryan',
    'TX-Corpus Christi',
    'TX-Dallas',
    'TX-El Paso',
    'TX-Harlingen',
    'TX-Houston',
    'TX-Laredo',
    'TX-Lubbock',
    'TX-Odessa',
    'TX-San Angelo',
    'TX-San Antonio',
    'TX-Tyler',
    'TX-Victoria',
    'TX-Wichita Falls',
    'UT-Salt Lake City',
    'VA-Charlottesville',
    'VA-Hampton Roads',
    'VA-Harrisonburg',
    'VA-Richmond',
    'VA-Roanoke',
    'VT-Burlington',
    'WA-Seattle',
    'WA-Spokane',
    'WI-Green Bay',
    'WI-La Crosse',
    'WI-Madison',
    'WI-Milwaukee',
    'WI-Wausau',
    'WV-Bluefield',
    'WV-Clarksburg',
    'WV-Parkersburg',
    'WY-Casper',
    'WY-Cheyenne',
  ],
  'CA - Provinces': [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland',
    'Northwest Territories',
    'Nova Scotia',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon',
  ],
  'CA - Metro Regions': [
    'AB-Calgary',
    'AB-Edmonton',
    'BC-Abbotsford',
    'BC-Kelowna',
    'BC-Vancouver',
    'MB-Winnipeg',
    'NB-Moncton',
    'NB-St. John',
    'NS-Halifax',
    'ON-Barrie',
    'ON-Brantford',
    'ON-Guelph',
    'ON-Hamilton',
    'ON-Kingston',
    'ON-Kitchener',
    'ON-London',
    'ON-Ottawa',
    'ON-Peterborough',
    'ON-St. Catherines',
    'ON-Sudbury',
    'ON-Thunder Bay',
    'ON-Toronto',
    'ON-Windsor',
    'PEI-Charlottetown',
    'QC-Chicoutimi',
    'QC-Montreal',
    'QC-Sherbrooke',
    'QC-Trois Rivieres',
    'SK-Regina',
    'SK-Saskatoon',
    'YT-Yellowknife',
  ],
  Africa: [
    'Algeria',
    'Angola',
    'Benin',
    'Botswana',
    'Burkina Faso',
    'Burundi',
    'Cameroon',
    'Cape Verde',
    'Central African Republic',
    'Chad',
    'Comoros',
    'Congo (DRC)',
    'Congo (Republic)',
    'Djibouti',
    'Egypt',
    'Equatorial Guinea',
    'Eritrea',
    'Ethiopia',
    'Gabon',
    'Gambia',
    'Ghana',
    'Guinea',
    'Guinea-Bissau',
    'Kenya',
    'Lesotho',
    'Liberia',
    'Libya',
    'Madagascar',
    'Malawi',
    'Mali',
    'Mauritania',
    'Mauritius',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Niger',
    'Nigeria',
    'Rwanda',
    'Sao Tome and Principe',
    'Senegal',
    'Seychelles',
    'Sierra Leone',
    'Somalia',
    'South Africa',
    'Sudan',
    'Swaziland',
    'Tanzania',
    'Togo',
    'Tunisia',
    'Uganda',
    'Zambia',
    'Zimbabwe',
    'Cabo Verde',
    "Côte d'Ivoire",
    'Eswatini',
    'French Southern Territories',
    'Mayotte',
    'Réunion',
    'Saint Helena, Ascension and Tristan da Cunha',
    'South Sudan',
    'Western Sahara',
  ],
  Asia: [
    'Afghanistan',
    'Armenia',
    'Azerbaijan',
    'Bahrain',
    'Bangladesh',
    'Bhutan',
    'Brunei Darussalam',
    'Cambodia',
    'China',
    'India',
    'Indonesia',
    'Iran',
    'Israel',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Lebanon',
    'Malaysia',
    'Maldives',
    'Mongolia',
    'Myanmar',
    'Nepal',
    'North Korea',
    'Oman',
    'Pakistan',
    'Philippines',
    'Qatar',
    'Saudi Arabia',
    'Singapore',
    'South Korea',
    'Sri Lanka',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Thailand',
    'Turkey',
    'Turkmenistan',
    'United Arab Emirates',
    'Uzbekistan',
    'Vietnam',
    'Yemen',
    'British Indian Ocean Territory',
    'Christmas Island',
    'Cocos Islands',
    'Hong Kong',
    'Iraq',
    'Macao',
    'Palestine',
  ],
  'Eastern Europe': [
    'Albania',
    'Belarus',
    'Bosnia Herzegovina',
    'Bulgaria',
    'Czech Republic',
    'Hungary',
    'Macedonia (FYROM)',
    'Moldova',
    'Poland',
    'Romania',
    'Russia',
    'Slovakia',
    'Ukraine',
    'Bosnia and Herzegovina',
    'Czechia',
    'Russian Federation',
  ],
  'Western Europe': [
    'Austria',
    'Belgium',
    'France',
    'Germany',
    'Liechtenstein',
    'Luxembourg',
    'Monaco',
    'Netherlands',
    'Switzerland',
    'Gibraltar',
  ],
  'Southern Europe': [
    'Andorra',
    'Croatia',
    'Cyprus',
    'Greece',
    'Italy',
    'Malta',
    'Portugal',
    'San Marino',
    'Slovenia',
    'Spain',
    'Holy See',
    'Montenegro',
    'North Macedonia',
    'Serbia',
  ],
  'Northern Europe': [
    'Denmark',
    'Estonia',
    'Finland',
    'Iceland',
    'Ireland',
    'Latvia',
    'Lithuania',
    'Norway',
    'Sweden',
    'United Kingdom',
    'Åland Islands',
    'Faroe Islands',
    'Guernsey',
    'Isle of Man',
    'Jersey',
    'Svalbard and Jan Mayen',
  ],
  'North America': [
    'Antigua and Barbuda',
    'Bahamas',
    'Barbados',
    'Belize',
    'Canada',
    'Costa Rica',
    'Cuba',
    'Dominica',
    'Dominican Republic',
    'El Salvador',
    'Grenada',
    'Guatemala',
    'Haiti',
    'Honduras',
    'Jamaica',
    'Mexico',
    'Nicaragua',
    'Panama',
    'Saint Kitts and Nevis',
    'Saint Vincent and the Grenadines',
    'Trinidad and Tobago',
    'United States',
    'Anguilla',
    'Aruba',
    'Bonaire, Sint Eustatius and Saba',
    'Cayman Islands',
    'Curaçao',
    'Greenland',
    'Guadeloupe',
    'Martinique',
    'Montserrat',
    'Saint Barthélemy',
    'Saint Lucia',
    'Saint Martin',
    'Saint Pierre and Miquelon',
    'Sint Maarten',
    'Turks and Caicos Islands',
  ],
  'South America': [
    'Argentina',
    'Bolivia',
    'Brazil',
    'Chile',
    'Colombia',
    'Ecuador',
    'Guyana',
    'Paraguay',
    'Peru',
    'Suriname',
    'Uruguay',
    'Venezuela',
    'Falkland Islands',
    'French Guiana',
    'South Georgia and the South Sandwich Islands',
  ],
  Oceania: [
    'Australia',
    'Cook Islands',
    'Fiji',
    'Kiribati',
    'New Zealand',
    'Papua New Guinea',
    'Samoa',
    'Solomon Islands',
    'Timor-Leste',
    'Tonga',
    'Vanuatu',
    'French Polynesia',
    'Heard Island and McDonald Islands',
    'Marshall Islands',
    'Micronesia',
    'Nauru',
    'New Caledonia',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Palau',
    'Pitcairn',
    'Tokelau',
    'Tuvalu',
    'United States Minor Outlying Islands',
    'Wallis and Futuna',
  ],
};
export const getRegionalData = (context: string, shouldCleanOutput?: boolean) => {
  if (context === 'mdqs') {
    return regionalData;
  }
  return {
    ...(shouldCleanOutput ? cleanedRegionalData : regionalData),
    'US - Metro Regions': shouldCleanOutput
      ? WITHOUT_STATE_US_METRO_REGIONS_CLEAN
      : WITHOUT_STATE_US_METRO_REGIONS,
    'CA - Metro Regions': shouldCleanOutput
      ? WITHOUT_STATE_CA_METRO_REGIONS_CLEAN
      : WITHOUT_STATE_CA_METRO_REGIONS,
  };
};
